import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaCotizaciones = ({anio, mes, vendedor, styles}) => {
    const tarjeta = "cotizaciones";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)

    const getData = async (anio,mes) => {
        setLoading(true);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&mes=${mes}&anio=${anio}&vendedor=${vendedor ? 1 : 0}`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(anio,mes);
    }, [anio, mes]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(data?.total)}
                    </div>
                    <div style={styles.subtitulo}>
                        Cotizaciones
                    </div>
                </div>

                <div className="row">
                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{data?.countFacturada}</small> {formatCurrency(data?.totalFacturada)}</strong>
                        </div>
                        <small style={styles.label}>Facturadas</small>
                    </div>
                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{(data?.countTotal || 0) - (data?.countFacturada || 0)}</small> {formatCurrency((data?.total || 0) - (data?.totalFacturada || 0))}</strong>
                        </div>
                        <small style={styles.label}>Cotizaciones</small>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TarjetaCotizaciones;
